import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import CancellationPolicyManagement from '../../../components/siteadmin/CancellationPolicy/CancellationPolicyManagement';

import getCancelPolicies from './getCancelPolicies.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './CancellationPolicies.css';
class CancellationPolicies extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getCancelPolicies: PropTypes.array,
        })
    };

    static defaultProps = {
        data: {
            loading: true
        }
    };

    render() {

        const { data: { getCancelPolicies, loading } } = this.props;
        return (
            <CancellationPolicyManagement
                data={getCancelPolicies}
                loading={loading}
            />
        );
    }
}

export default compose(
    withStyles(s),
    withQuery(getCancelPolicies,
        {
            options: {
                fetchPolicy: 'network-only',
                ssr: false
            }
        }),
)(CancellationPolicies);